import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { type IAtalasoftSigningProps } from "commonComponents/entity/media/signatures/Signing/AtalasoftSigning";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const AtalasoftSigning = lazyLoadComponent(
    () => import("commonComponents/entity/media/signatures/Signing/AtalasoftSigning"),
);

export const RouteAtalasoftSigning = ({
    modalConfig,
}: Omit<IAtalasoftSigningProps, "documentInstanceId" | "builderId" | "loginType">) => (
    <RouteRelative
        path={routes.signatureRequest.sign}
        render={(routeProps) => {
            const documentInstanceId = parseInt(routeProps.match.params.documentInstanceId);
            const builderId = parseInt(routeProps.match.params.builderId);
            const loginType = parseInt(routeProps.match.params.loginType);

            return (
                <BTSuspense>
                    <AtalasoftSigning
                        documentInstanceId={documentInstanceId}
                        loginType={loginType}
                        builderId={builderId}
                        modalConfig={modalConfig}
                    />
                </BTSuspense>
            );
        }}
    />
);
